var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInvoiceSolid = function SvgInvoiceSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.586 20.414A2 2 0 0 0 7 21h10a2 2 0 0 0 2-2V8h-5V3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 .586 1.414ZM12.75 10a.75.75 0 0 0-1.5 0v.764a2.25 2.25 0 0 0 .25 4.486h1a.75.75 0 1 1 0 1.5H10a.75.75 0 0 0 0 1.5h1.25V19a.75.75 0 0 0 1.5 0v-.764a2.25 2.25 0 0 0-.25-4.486h-1a.75.75 0 1 1 0-1.5H14a.75.75 0 0 0 0-1.5h-1.25V10Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 21H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7l2.5 2.5L19 8v11a2 2 0 0 1-2 2Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgInvoiceSolid;